import React from "react";
import TextField from "@mui/material/TextField";
import { GoPlusCircle } from "react-icons/go";
import CloseIcon from "@mui/icons-material/Close";
import { MdOutlineDelete } from "react-icons/md";
import { Draggable, Droppable } from "react-beautiful-dnd";
import useTitanApp from "../../../../../hooks/useTitanApp";

function AddPatientTemplateSection({
  section,
  sectionIndex,
  errors,
  onSectionTitleChange,
  onControlLabelChange,
  onAddUserControl,
  onDeleteUserControl,
  onDeleteSection,
}) {
  const { appState } = useTitanApp();
  const { darkMode } = appState || {};

  return (
    <div className="autocue_questions_content">
      <div className="autocue_sectionTitle">
        <div className="sectionTitle_heading">
          <p className="sectionTitle_Number">{sectionIndex + 1}</p>
          <span>
            <p
              className={`sectionTitle_Text editable_sectionTitle ${
                errors.sections[sectionIndex]?.sectionTitle ? "invalid" : ""
              }`}
              contentEditable
              suppressContentEditableWarning
              onBlur={(e) =>
                onSectionTitleChange(sectionIndex, e.target.innerText.trim())
              }
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  e.currentTarget.blur();
                }
              }}
              data-placeholder="Enter section title"
            >
              {section.sectionTitle}
            </p>
          </span>
        </div>

        <div className="sectionActions">
          <GoPlusCircle
            fill="#999999"
            className="add_user_control_icon"
            style={{ cursor: "pointer", marginLeft: "8px" }}
            size={20}
            onClick={() => onAddUserControl(sectionIndex)}
            />

          <CloseIcon
            fill="#999999"
            className="add_user_control_icon"
            size={20}
            onClick={() => onDeleteSection(sectionIndex)}
            style={{ cursor: "pointer", marginLeft: "8px" }}
          />
        </div>
      </div>

      <Droppable
        droppableId={`questions-${sectionIndex}`}
        type={`question-${sectionIndex}`}
      >
        {(providedQ) => (
          <div
            ref={providedQ.innerRef}
            {...providedQ.droppableProps}
            className="autocue_questions_list"
          >
            {section.userControls.map((control, controlIndex) => (
              <Draggable
                key={control.id}
                draggableId={control.id}
                index={controlIndex}
              >
                {(providedQC, snapshot) => (
                  <div
                    ref={providedQC.innerRef}
                    {...providedQC.draggableProps}
                    {...providedQC.dragHandleProps}
                    className={`userControlWrapper ${snapshot.isDragging ? "dragging" : ""}`}
                    style={{
                        ...providedQC.draggableProps.style,
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      marginBottom: "8px",
                    }}
                  >
                    <TextField
                      label={`Question ${controlIndex + 1}`}
                      value={control.label}
                      onChange={(e) =>
                        onControlLabelChange(
                          sectionIndex,
                          controlIndex,
                          e.target.value
                        )
                      }
                      fullWidth
                      multiline
                      minRows={1}
                      maxRows={4}
                      required={control.required}
                      error={
                        errors.sections[sectionIndex]?.userControls?.[
                          controlIndex
                        ] || false
                      }
                      helperText={
                        errors.sections[sectionIndex]?.userControls?.[
                          controlIndex
                        ]
                          ? "This field is required"
                          : ""
                      }
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "16px",
                          backgroundColor: darkMode ? "#111" : "#fff",
                          fontSize: "14px",
                        },
                        "& .MuiInputBase-input": {
                          fontSize: "14px",
                        },
                        "& .MuiInputLabel-root": {
                          fontSize: "14px",
                        },
                      }}
                    />

                    <MdOutlineDelete
                      size={24}
                      fill="#999999"
                      className="user_control_delete_icon"
                      onClick={() =>
                        onDeleteUserControl(sectionIndex, controlIndex)
                      }
                      title="Delete Question"
                    />
                  </div>
                )}
              </Draggable>
            ))}
            {providedQ.placeholder}
          </div>
        )}
      </Droppable>
    </div>
  );
}

export default AddPatientTemplateSection;
